"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _webApi = require("../../utils/web-api");
var _AuthContext = require("../../context/AuthContext");
var _button = require("@design/ui/button");
var _dialog = require("@design/ui/dialog");
var _input = require("@design/ui/input");
var _label = require("@design/ui/label");
var _select = require("@design/ui/select");
var _textarea = require("@design/ui/textarea");
var _AnalyticsContext = require("../../context/AnalyticsContext");
var _toast = require("../../utils/toast");
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t3 in e) "default" !== _t3 && {}.hasOwnProperty.call(e, _t3) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t3)) && (i.get || i.set) ? o(f, _t3, i) : f[_t3] = e[_t3]); return f; })(e, t); }
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i.return) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
var NO_BASE_PLAYBOOK = "none";
var CreatePlaybookModal = function CreatePlaybookModal(_ref) {
  var isOpen = _ref.isOpen,
    onClose = _ref.onClose,
    onSuccess = _ref.onSuccess;
  var _useState = (0, _react.useState)(""),
    _useState2 = _slicedToArray(_useState, 2),
    playbookName = _useState2[0],
    setPlaybookName = _useState2[1];
  var _useState3 = (0, _react.useState)(""),
    _useState4 = _slicedToArray(_useState3, 2),
    description = _useState4[0],
    setDescription = _useState4[1];
  var _useState5 = (0, _react.useState)(""),
    _useState6 = _slicedToArray(_useState5, 2),
    selectedPlaybookId = _useState6[0],
    setSelectedPlaybookId = _useState6[1];
  var _useState7 = (0, _react.useState)([]),
    _useState8 = _slicedToArray(_useState7, 2),
    playbooks = _useState8[0],
    setPlaybooks = _useState8[1];
  var _useState9 = (0, _react.useState)(false),
    _useState0 = _slicedToArray(_useState9, 2),
    isLoading = _useState0[0],
    setIsLoading = _useState0[1];
  var authHeader = (0, _AuthContext.useAuthHeader)();
  var _useAnalytics = (0, _AnalyticsContext.useAnalytics)(),
    sendError = _useAnalytics.sendError;
  var fieldId = (0, _react.useId)();
  (0, _react.useEffect)(function () {
    var loadPlaybooks = /*#__PURE__*/function () {
      var _ref2 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
        var data, _t;
        return _regenerator().w(function (_context) {
          while (1) switch (_context.p = _context.n) {
            case 0:
              if (authHeader) {
                _context.n = 1;
                break;
              }
              return _context.a(2);
            case 1:
              _context.p = 1;
              _context.n = 2;
              return (0, _webApi.fetchPlaybooks)(authHeader);
            case 2:
              data = _context.v;
              if (data) {
                setPlaybooks(data);
              }
              _context.n = 4;
              break;
            case 3:
              _context.p = 3;
              _t = _context.v;
              console.error("Failed to load playbooks:", _t);
              sendError(_t, {
                component: "CreatePlaybookModal",
                action: "load_playbooks"
              });
              (0, _toast.toastError)("Failed to load playbooks");
            case 4:
              return _context.a(2);
          }
        }, _callee, null, [[1, 3]]);
      }));
      return function loadPlaybooks() {
        return _ref2.apply(this, arguments);
      };
    }();
    if (isOpen) {
      loadPlaybooks();
    }
  }, [isOpen]);
  var handleSubmit = /*#__PURE__*/function () {
    var _ref3 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2() {
      var newPlaybook, selectedPlaybook, finalName, finalDescription, _t2;
      return _regenerator().w(function (_context2) {
        while (1) switch (_context2.p = _context2.n) {
          case 0:
            if (!(!playbookName.trim() && !selectedPlaybookId)) {
              _context2.n = 1;
              break;
            }
            return _context2.a(2);
          case 1:
            if (authHeader) {
              _context2.n = 2;
              break;
            }
            return _context2.a(2);
          case 2:
            setIsLoading(true);
            _context2.p = 3;
            if (!selectedPlaybookId) {
              _context2.n = 5;
              break;
            }
            selectedPlaybook = playbooks.find(function (playbook) {
              return playbook.id === selectedPlaybookId;
            });
            finalName = playbookName.trim() || "Copy of ".concat(selectedPlaybook === null || selectedPlaybook === void 0 ? void 0 : selectedPlaybook.name);
            finalDescription = description.trim() || (selectedPlaybook === null || selectedPlaybook === void 0 ? void 0 : selectedPlaybook.description) || "";
            _context2.n = 4;
            return (0, _webApi.duplicatePlaybook)(authHeader, selectedPlaybookId, finalName, finalDescription);
          case 4:
            newPlaybook = _context2.v;
            _context2.n = 7;
            break;
          case 5:
            _context2.n = 6;
            return (0, _webApi.createPlaybook)(authHeader, playbookName.trim(), description.trim());
          case 6:
            newPlaybook = _context2.v;
          case 7:
            onSuccess === null || onSuccess === void 0 || onSuccess(newPlaybook.id);
            handleClose();
            _context2.n = 9;
            break;
          case 8:
            _context2.p = 8;
            _t2 = _context2.v;
            console.error("Failed to create playbook:", _t2);
            sendError(_t2, {
              component: "CreatePlaybookModal",
              action: "create_playbook",
              playbookName: playbookName.trim(),
              basePlaybookId: selectedPlaybookId || undefined
            });
            (0, _toast.toastError)("Failed to create playbook");
          case 9:
            _context2.p = 9;
            setIsLoading(false);
            return _context2.f(9);
          case 10:
            return _context2.a(2);
        }
      }, _callee2, null, [[3, 8, 9, 10]]);
    }));
    return function handleSubmit() {
      return _ref3.apply(this, arguments);
    };
  }();
  var handleClose = function handleClose() {
    setPlaybookName("");
    setDescription("");
    setSelectedPlaybookId("");
    setIsLoading(false);
    onClose();
  };
  function submitForm(event) {
    event.preventDefault();
    if (canSubmit) void handleSubmit();
  }
  var canSubmit = (playbookName.trim().length > 0 || selectedPlaybookId.length > 0) && !isLoading;
  var nameField = /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
    className: "flex flex-col gap-2",
    children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)(_label.Label, {
      htmlFor: "".concat(fieldId, "-name"),
      children: ["Playbook name", /*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
        className: "text-destructive",
        children: "*"
      })]
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_input.Input, {
      id: "".concat(fieldId, "-name"),
      "data-autofocus": true,
      value: playbookName,
      onChange: function onChange(e) {
        return setPlaybookName(e.target.value);
      },
      placeholder: "Enter playbook name"
    })]
  });
  var descriptionField = /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
    className: "flex flex-col gap-2",
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_label.Label, {
      htmlFor: "".concat(fieldId, "-description"),
      children: "Description"
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_textarea.Textarea, {
      id: "".concat(fieldId, "-description"),
      rows: 3,
      className: "resize-none",
      value: description,
      onChange: function onChange(e) {
        return setDescription(e.target.value);
      },
      placeholder: "Enter playbook description"
    })]
  });
  var basePlaybookField = /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
    className: "flex flex-col gap-2",
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_label.Label, {
      htmlFor: "".concat(fieldId, "-base"),
      children: "Select base playbook (optional)"
    }), /*#__PURE__*/(0, _jsxRuntime.jsxs)(_select.Select, {
      value: selectedPlaybookId,
      onValueChange: function onValueChange(value) {
        return setSelectedPlaybookId(value === NO_BASE_PLAYBOOK ? "" : value);
      },
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_select.SelectTrigger, {
        id: "".concat(fieldId, "-base"),
        className: "w-full",
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_select.SelectValue, {
          placeholder: "Select a playbook"
        })
      }), /*#__PURE__*/(0, _jsxRuntime.jsxs)(_select.SelectContent, {
        children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_select.SelectItem, {
          value: NO_BASE_PLAYBOOK,
          children: "None"
        }), playbooks.map(function (playbook) {
          return /*#__PURE__*/(0, _jsxRuntime.jsx)(_select.SelectItem, {
            value: playbook.id,
            children: playbook.name
          }, playbook.id);
        })]
      })]
    })]
  });
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_dialog.Dialog, {
    open: isOpen,
    onOpenChange: handleClose,
    "data-sentry-element": "Dialog",
    "data-sentry-component": "CreatePlaybookModal",
    "data-sentry-source-file": "CreatePlaybookModal.tsx",
    children: /*#__PURE__*/(0, _jsxRuntime.jsxs)(_dialog.DialogContent, {
      "data-sentry-element": "DialogContent",
      "data-sentry-source-file": "CreatePlaybookModal.tsx",
      children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)(_dialog.DialogHeader, {
        "data-sentry-element": "DialogHeader",
        "data-sentry-source-file": "CreatePlaybookModal.tsx",
        children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_dialog.DialogTitle, {
          "data-sentry-element": "DialogTitle",
          "data-sentry-source-file": "CreatePlaybookModal.tsx",
          children: "Create new playbook"
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_dialog.DialogDescription, {
          "data-sentry-element": "DialogDescription",
          "data-sentry-source-file": "CreatePlaybookModal.tsx",
          children: "Give it a name, optionally add a description, and you can base it on an existing playbook."
        })]
      }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("form", {
        onSubmit: submitForm,
        className: "contents",
        children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
          className: "flex flex-col gap-4",
          children: [nameField, descriptionField, basePlaybookField]
        }), /*#__PURE__*/(0, _jsxRuntime.jsxs)(_dialog.DialogFooter, {
          "data-sentry-element": "DialogFooter",
          "data-sentry-source-file": "CreatePlaybookModal.tsx",
          children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_button.Button, {
            type: "button",
            variant: "outline",
            onClick: handleClose,
            "data-sentry-element": "Button",
            "data-sentry-source-file": "CreatePlaybookModal.tsx",
            children: "Cancel"
          }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_button.Button, {
            type: "submit",
            disabled: !canSubmit,
            "data-sentry-element": "Button",
            "data-sentry-source-file": "CreatePlaybookModal.tsx",
            children: isLoading ? "Creating..." : "Create playbook"
          })]
        })]
      })]
    })
  });
};
var _default = exports.default = CreatePlaybookModal;